<template>
  <div>
    <b-form class="form profile-name">
      <b-row>
        <b-col cols="4">
          <b-form-group
            label="Enter Video URL"
            label-for="input-3"
            class="custom-label"
          >
            <b-form-input
              id="input-3"
              v-model="videoURL"
              class="custom-input"
              placeholder="https://"
              type="text"
              :disabled="inputVideoURLDisabled"
            />
          </b-form-group>
          <b-button @click="handleAddVideo" style="height: fit-content">
            Add
          </b-button>

          <b-button @click="handleData">
            Click Me
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Settings_GamePromo",
  props: {
    publishing: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      inputVideoURLDisabled: false,
      videoURL: "",
      settings: {
        videoURL: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    })
  },
  methods: {
    handleData() {
      //console.log(`Publishing ${this.publishing}`);
      //console.log(`Resource ${this.resource}`);
      //console.log(`Resource Tool Id ${this.resource.tool_id}`);
    },
    handleChange(changeMade) {
      //console.log(changeMade);
    },
    handleAddVideo() {
      //console.log(`handleAddVideo URL ${this.videoURL}`);
      const embedData = this.getEmbedUrl(this.videoURL);
      //console.log(`Embed Data ${JSON.stringify(embedData)}`);

      let videoToSave = {
        video_url: embedData.url,
        img_url: embedData.img,
        videoId: embedData.videoId
      };

      //console.log(`Video to Save ${videoToSave}`);

      /*  this.$store.dispatch("resources/addVideoIntoResource", {
        video: videoToSave,
        publishing_id: this.publishing,
        resource_id: this.resource.tools_id
      });
      this.addPlan({
        video: videoToSave,
        focusId: this.focus.focusId,
        tools_id: this.tool.tools_id
      });
      this.inputYtbUrl = "";
      */
    },
    getEmbedUrl(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      let videoId = match && match[2].length === 11 ? match[2] : null;
      return {
        url: `https://www.youtube.com/embed/${videoId}`,
        img: `https://img.youtube.com/vi/${videoId}/0.jpg`,
        videoId: videoId
      };
    } //TODO- Mixin
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
